/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'theme_general',
        title: 'Général',
        type: 'group',
        children: [
            {
                id: 'general_patient_management',
                title: 'Gestion des patients',
                type: 'collapsable',
                icon: 'heroicons_outline:users',
                children: [
                    {
                        id: 'patient_dashboard',
                        title: 'Tableau de bord',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-bar-square',
                        link: '/patient-dashboard',
                    },
                    {
                        id: 'patients',
                        title: 'Patients',
                        type: 'basic',
                        icon: 'heroicons_outline:identification',
                        link: '/patients',
                    },
                    {
                        id: 'admissions',
                        title: 'Admissions',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/admissions',
                    },
                    {
                        id: 'medical_service_lines',
                        title: 'Détail admission',
                        type: 'basic',
                        icon: 'heroicons_outline:rectangle-group',
                        link: '/medical-service-lines',
                    },
                    {
                        id: 'hospitalizations',
                        title: 'Hospitalisations',
                        type: 'basic',
                        icon: 'heroicons_outline:building-office-2',
                        link: '/hospitalization',
                    },
                ],
            },
            {
                id: 'planning',
                title: 'Planning',
                type: 'collapsable',
                icon: 'heroicons_outline:calendar',
                children: [
                    {
                        id: 'planning_calendar',
                        title: 'Calendrier',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar',
                        link: '/planning',
                        exactMatch: true,
                    },
                    {
                        id: 'planning_requests',
                        title: 'Rendez-vous',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar',
                        link: '/planning/request',
                    },
                ],
            },
            {
                id: 'queue',
                title: "File d'attente",
                type: 'basic',
                icon: 'heroicons_outline:queue-list',
                link: '/queue',
            },
        ],
    },
];

export const patientManagementNavigation: FuseNavigationItem[] = [
    {
        ...defaultNavigation[0],
        children: defaultNavigation[0].children?.filter(
            (item) => item.id === 'general_patient_management'
        ),
    },
];

export const billingNavigation: FuseNavigationItem = {
    id: 'billing',
    title: 'Comptabilité',
    type: 'group',
    children: [
        {
            id: 'billing_client_section',
            title: 'Facturation client',
            type: 'collapsable',
            icon: 'heroicons_outline:currency-dollar',
            children: [
                {
                    id: 'billing_client_dashboard',
                    title: 'Tableau de bord',
                    type: 'basic',
                    icon: 'heroicons_outline:chart-bar-square',
                    link: '/billing/dashboard',
                },
                {
                    id: 'billing_client_list',
                    title: 'Facturation client',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/billing/list/',
                },
                {
                    id: 'billing_client_daily_state',
                    title: 'Etat des factures par mutuelles',
                    type: 'basic',
                    icon: 'heroicons_outline:table-cells',
                    link: '/billing/daily-state',
                },
                {
                    id: 'billing_client_daily_state_v2',
                    title: 'Etat des Factures',
                    type: 'basic',
                    icon: 'heroicons_outline:queue-list',
                    link: '/billing/daily-state-v2',
                },
                {
                    id: 'cash_register',
                    title: 'Brouillard de caisse',
                    type: 'basic',
                    icon: 'heroicons_outline:calculator',
                    link: '/billing/cash-register',
                },
            ],
        },
        {
            id: 'billing_mutual_section',
            title: 'Factures mutuelle',
            type: 'collapsable',
            icon: 'heroicons_outline:currency-dollar',
            children: [
                {
                    id: 'billing_mutual_dashboard',
                    title: 'Tableau de bord',
                    type: 'basic',
                    icon: 'heroicons_outline:chart-pie',
                    link: '/mutualsInvoice/dashboard',
                },
                {
                    id: 'billing_mutual_list',
                    title: 'Liste des Factures',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/mutualsInvoice',
                    exactMatch: true,
                },
                {
                    id: 'billing_mutual_preview',
                    title: 'Etat factures mutuelles',
                    type: 'basic',
                    icon: 'heroicons_outline:table-cells',
                    link: '/mutualsInvoice/preview',
                },
                {
                    id: 'billing_mutual_add',
                    title: 'Ajouter une Facture',
                    type: 'basic',
                    icon: 'heroicons_outline:plus-circle',
                    link: '/mutualsInvoice/add',
                },
            ],
        },
    ],
};

export const billingNavigationCaisse: FuseNavigationItem = {
    id: 'billing_caisse',
    title: 'Caisse',
    type: 'group',
    children: [
        {
            id: 'billing_caisse_dashboard',
            title: 'Tableau de bord',
            type: 'basic',
            icon: 'heroicons_outline:chart-bar-square',
            link: '/billing/dashboard',
        },
        {
            id: 'billing_caisse_list',
            title: 'Facturation client',
            type: 'basic',
            icon: 'heroicons_outline:document-text',
            link: '/billing/list',
        },
        {
            id: 'cash_register_caisse',
            title: 'Brouillard de caisse',
            type: 'basic',
            icon: 'heroicons_outline:calculator',
            link: '/billing/cash-register',
        },
    ],
};

export const stockNavigation: FuseNavigationItem = {
    id: 'stock',
    title: 'Grand Stock',
    type: 'group',
    children: [
        {
            id: 'grand_stock_dashboard',
            title: 'Tableau de bord',
            type: 'basic',
            icon: 'heroicons_outline:chart-pie',
            link: '/stock/dashboard',
        },
        {
            id: 'stock_management_section',
            title: 'Gestion du stock',
            type: 'collapsable',
            icon: 'heroicons_outline:archive-box',
            children: [
                {
                    id: 'grand_stock_list',
                    title: 'Stock',
                    type: 'basic',
                    icon: 'heroicons_outline:archive-box',
                    link: '/stock/list',
                },
                {
                    id: 'grand_stock_low_stock',
                    title: 'Stock sous le seuil',
                    type: 'basic',
                    icon: 'heroicons_outline:exclamation-triangle',
                    link: '/stock/low-stock',
                },
                {
                    id: 'grand_stock_create_product',
                    title: 'Création de produit',
                    type: 'basic',
                    icon: 'heroicons_outline:plus-circle',
                    link: '/stock/products/create',
                },
                {
                    id: 'grand_stock_create_reagent',
                    title: 'Création de réactif',
                    type: 'basic',
                    icon: 'heroicons_outline:plus-circle',
                    link: '/stock/reagents/create',
                },
                {
                    id: 'grand_stock_create_supplier',
                    title: 'Création de fournisseur',
                    type: 'basic',
                    icon: 'heroicons_outline:plus-circle',
                    link: '/stock/suppliers/create',
                },
                {
                    id: 'grand_stock_create',
                    title: 'Entrer dans le stock',
                    type: 'basic',
                    icon: 'heroicons_outline:plus-circle',
                    link: '/stock/create',
                },
                {
                    id: 'grand_stock_delivery_note',
                    title: 'Bons de livraison',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/stock/delivery-notes',
                },
                {
                    id: 'grand_stock_history',
                    title: 'Historique',
                    type: 'basic',
                    icon: 'heroicons_outline:clock',
                    link: '/stock/history',
                },
            ],
        },
        {
            id: 'grand_stock_inv',
            title: 'Inventaire',
            type: 'collapsable',
            icon: 'heroicons_outline:clipboard-document-check',
            children: [
                {
                    id: 'grand_stock_inventory',
                    title: "Faire l'inventaire du grand stock",
                    type: 'basic',
                    icon: 'heroicons_outline:clipboard-document-list',
                    link: '/stock/inventory',
                },
                {
                    id: 'grand_stock_inventories',
                    title: 'Inventaires',
                    type: 'basic',
                    icon: 'heroicons_outline:queue-list',
                    link: '/stock/inventories',
                },
            ],
        },
        {
            id: 'grand_stock_requests',
            title: 'Demandes de transfert',
            type: 'basic',
            icon: 'heroicons_outline:arrow-path',
            link: '/stock/requests',
        },
    ],
};

export const pharmacieNavigation: FuseNavigationItem = {
    id: 'pharmacie',
    title: 'Pharmacie',
    type: 'group',
    children: [
        {
            id: 'pharmacie_dashboard',
            title: 'Tableau de bord',
            type: 'basic',
            icon: 'heroicons_outline:chart-pie',
            link: '/pharmacie/dashboard',
        },
        {
            id: 'pharmacie_sales_state',
            title: 'Etat des ventes',
            type: 'basic',
            icon: 'heroicons_outline:chart-bar-square',
            link: '/pharmacie/sales-state',
        },
        {
            id: 'pharmacie_stock_section',
            title: 'Gestion du stock',
            type: 'collapsable',
            icon: 'heroicons_outline:archive-box',
            children: [
                {
                    id: 'pharmacie_stock',
                    title: 'Gestion du stock',
                    type: 'basic',
                    icon: 'heroicons_outline:archive-box',
                    link: '/pharmacie/stock',
                },
                {
                    id: 'pharmacie_stock_history',
                    title: 'Historique',
                    type: 'basic',
                    icon: 'heroicons_outline:clock',
                    link: '/pharmacie/history',
                },
                {
                    id: 'pharmacie_consumption',
                    title: 'Consommation',
                    type: 'basic',
                    icon: 'heroicons_outline:beaker',
                    link: '/pharmacie/consumption',
                },
            ],
        },
        {
            id: 'pharmacie_inv',
            title: 'Inventaire',
            type: 'collapsable',
            icon: 'heroicons_outline:clipboard-document-check',
            children: [
                {
                    id: 'pharmacie_inventory',
                    title: "Faire l'inventaire du stock pharmacie",
                    type: 'basic',
                    icon: 'heroicons_outline:clipboard-document-list',
                    link: '/pharmacie/inventory',
                },
                {
                    id: 'pharmacie_inventories',
                    title: 'Inventaires',
                    type: 'basic',
                    icon: 'heroicons_outline:queue-list',
                    link: '/pharmacie/inventories',
                },
            ],
        },
        {
            id: 'pharmacie_transfer_request',
            title: 'Demande de transfert',
            type: 'basic',
            icon: 'heroicons_outline:arrow-path',
            link: '/pharmacie/transfer-request',
        },
        {
            id: 'pharmacie_transfer_requests',
            title: 'Demandes de transfert',
            type: 'basic',
            icon: 'heroicons_outline:queue-list',
            link: '/pharmacie/transfer-requests',
        },
    ],
};

export const laboratoireNavigation: FuseNavigationItem = {
    id: 'laboratoire',
    title: 'Laboratoire',
    type: 'group',
    children: [
        {
            id: 'laboratoire_dashboard',
            title: 'Tableau de bord',
            type: 'basic',
            icon: 'heroicons_outline:chart-pie',
            link: '/laboratoire/dashboard',
        },
        {
            id: 'laboratoire_stock_section',
            title: 'Gestion du stock',
            type: 'collapsable',
            icon: 'heroicons_outline:archive-box',
            children: [
                {
                    id: 'laboratoire_stock',
                    title: 'Gestion du stock',
                    type: 'basic',
                    icon: 'heroicons_outline:archive-box',
                    link: '/laboratoire/stock',
                },
                {
                    id: 'laboratoire_stock_history',
                    title: 'Historique',
                    type: 'basic',
                    icon: 'heroicons_outline:clock',
                    link: '/laboratoire/history',
                },
                {
                    id: 'laboratoire_consumption',
                    title: 'Consommation',
                    type: 'basic',
                    icon: 'heroicons_outline:beaker',
                    link: '/laboratoire/consumption',
                },
            ],
        },
        {
            id: 'laboratoire_inv',
            title: 'Inventaire',
            type: 'collapsable',
            icon: 'heroicons_outline:clipboard-document-check',
            children: [
                {
                    id: 'laboratoire_inventory',
                    title: "Faire l'inventaire du stock laboratoire",
                    type: 'basic',
                    icon: 'heroicons_outline:clipboard-document-list',
                    link: '/laboratoire/inventory',
                },
                {
                    id: 'laboratoire_inventories',
                    title: 'Inventaires',
                    type: 'basic',
                    icon: 'heroicons_outline:queue-list',
                    link: '/laboratoire/inventories',
                },
            ],
        },
        {
            id: 'laboratoire_analysis',
            title: 'Analyse',
            type: 'collapsable',
            icon: 'heroicons_outline:beaker',
            children: [
                {
                    id: 'analysis_ready',
                    title: 'Analyses à effectuer',
                    type: 'basic',
                    icon: 'heroicons_outline:beaker',
                    link: '/analysisResults',
                    exactMatch: true,
                },
                {
                    id: 'analysis_results_global',
                    title: "Résultats d'analyses",
                    type: 'basic',
                    icon: 'heroicons_outline:beaker',
                    link: '/analysisResults/global',
                },
            ],
        },
        {
            id: 'laboratoire_transfer_request',
            title: 'Demande de transfert',
            type: 'basic',
            icon: 'heroicons_outline:arrow-path',
            link: '/laboratoire/transfer-request',
        },
        {
            id: 'laboratoire_transfer_requests',
            title: 'Demandes de transfert',
            type: 'basic',
            icon: 'heroicons_outline:queue-list',
            link: '/laboratoire/transfer-requests',
        },
    ],
};

export const administrationNavigation: FuseNavigationItem = {
    id: 'administration',
    title: 'Administration',
    type: 'group',
    children: [
        {
            id: 'administration_users',
            title: 'Utilisateurs',
            type: 'collapsable',
            icon: 'heroicons_outline:user-group',
            children: [
                {
                    id: 'users_list',
                    title: 'Liste des Utilisateurs',
                    type: 'basic',
                    icon: 'heroicons_outline:user-group',
                    link: '/users',
                },
            ],
        },
        {
            id: 'administration_settings',
            title: 'Paramétrage',
            type: 'collapsable',
            icon: 'heroicons_outline:document-chart-bar',
            children: [
                {
                    id: 'settings_establishment',
                    title: 'Clinique',
                    type: 'basic',
                    icon: 'heroicons_outline:building-office-2',
                    link: '/settings/establishment',
                },
                {
                    id: 'settings_motifs',
                    title: "Motifs d'admision",
                    type: 'basic',
                    icon: 'heroicons_outline:identification',
                    link: '/settings/motifs-admission',
                },
                {
                    id: 'settings_services',
                    title: 'Unité/Service médical',
                    type: 'basic',
                    icon: 'heroicons_outline:identification',
                    link: '/settings/service-medical',
                },
                {
                    id: 'actes',
                    title: 'Actes médicaux',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/acts',
                },
                {
                    id: 'mutuals',
                    title: 'Mutuelles',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/mutuals',
                },
                {
                    id: 'products',
                    title: 'Produits',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/products',
                },
                {
                    id: 'product-kits',
                    title: 'Kits de produits',
                    type: 'basic',
                    icon: 'heroicons_outline:squares-plus',
                    link: '/product-kits',
                },
                {
                    id: 'analysis_settings',
                    title: 'Analyses',
                    type: 'basic',
                    icon: 'heroicons_outline:beaker',
                    link: '/settings/analysis',
                },
                {
                    id: 'services',
                    title: 'Services',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/settings/service-catalog',
                },
                {
                    id: 'suppliers',
                    title: 'Fournisseurs',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/settings/suppliers',
                },
                {
                    id: 'reagents',
                    title: 'Réactifs',
                    type: 'basic',
                    icon: 'heroicons_outline:beaker',
                    link: '/settings/reagents',
                },
                {
                    id: 'payment_methods',
                    title: 'Moyens de paiement',
                    type: 'basic',
                    icon: 'heroicons_outline:credit-card',
                    link: '/settings/payment-methods',
                },
            ],
        },
    ],
};

export const userNavigation: FuseNavigationItem = administrationNavigation;
export const settingsNavigation: FuseNavigationItem = administrationNavigation;

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
